const state = {
  userDetails: null,
  usersModels: null
}
export default state
